import {
  Nav,
  NavContainer,
  NavLogoContainer,
  NavLogoText,
  NavMenu,
  MobileIcon,
  PlayIcon,
  NavLinks,
  NavItem,
  NavBtn,
  NavBtnLink,
} from "./NavbarElements";
import { FaBars, FaPlayCircle } from "react-icons/fa";
import { animateScroll as scroll } from "react-scroll";
import { useEffect, useState } from "react";

const Navbar = ({ toggle }) => {
  const [scrollNav, setScrollNav] = useState(false);

  const changeNav = () => {
    if (window.scrollY >= 80) {
      setScrollNav(true);
    } else {
      setScrollNav(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", changeNav);
  }, []);

  const toggleHome = () => {
    scroll.scrollToTop();
  };
  return (
    <>
      <Nav scrollNav={scrollNav}>
        <NavContainer>
          <NavLogoContainer to="/" onClick={toggleHome}>
            <NavLogoText>Paythumb</NavLogoText>
          </NavLogoContainer>
          <MobileIcon onClick={toggle}>
            <FaBars />
          </MobileIcon>
          <NavMenu>
            <NavItem>
              <NavLinks
                to="Howitworks"
                smooth={true}
                duration={500}
                spy={true}
                exact="true"
                offset={-80}
              >
                How It Works
                {/* TODO: Will use this icon when we have a video to show */}
                {/* <PlayIcon>
                  <FaPlayCircle />
                </PlayIcon> */}
              </NavLinks>
            </NavItem>
            <NavItem>
              <NavLinks
                to="Agents"
                smooth={true}
                duration={500}
                spy={true}
                exact="true"
                offset={-80}
              >
                For Agents
              </NavLinks>
            </NavItem>
            <NavItem>
              <NavLinks
                to="FB"
                smooth={true}
                duration={500}
                spy={true}
                exact="true"
                offset={-80}
              >
                For Business
              </NavLinks>
            </NavItem>
            <NavItem>
              <NavLinks
                to="Pricing"
                smooth={true}
                duration={500}
                spy={true}
                exact="true"
                offset={-80}
              >
                Pricing
              </NavLinks>
            </NavItem>
          </NavMenu>
          <NavBtn>
            <NavBtnLink
              to="Waitlist"
              smooth={true}
              duration={500}
              spy={true}
              exact="true"
              offset={-80}
            >
              Join Wait list
            </NavBtnLink>
          </NavBtn>
        </NavContainer>
      </Nav>
    </>
  );
};

export default Navbar;
